(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-small-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(carousel) {
      var container = carousel.querySelector('.card-small-image-container');
      var prev = carousel.querySelector('.card-carousel-btn--prev');
      var next = carousel.querySelector('.card-carousel-btn--next');
      if (!container || !prev || !next) return;

      function update() {
        var maxScroll = container.scrollWidth - container.clientWidth;
        // Toggle button visibility based on whether the track actually overflows.
        carousel.classList.toggle('no-overflow', maxScroll <= 1);
        prev.disabled = container.scrollLeft <= 1;
        next.disabled = container.scrollLeft >= maxScroll - 1;
      }

      prev.addEventListener('click', function () {
        container.scrollBy({ left: -container.clientWidth, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        container.scrollBy({ left: container.clientWidth, behavior: 'smooth' });
      });
      container.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    document
      .querySelectorAll('.card-small-image-carousel.is-carousel')
      .forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar-body"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimerBody extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode;
      this.target = this.resolveTarget();

      this.els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    resolveTarget() {
      if (this.mode === 'evergreen') {
        const key = this.dataset.storageKey;
        const duration = parseInt(this.dataset.duration, 10) || 0;
        let stored = null;
        try {
          stored = window.localStorage.getItem(key);
        } catch (e) {
          stored = null;
        }
        let target = stored ? parseInt(stored, 10) : NaN;
        if (!target || isNaN(target) || target <= Date.now()) {
          target = Date.now() + duration;
          try {
            window.localStorage.setItem(key, String(target));
          } catch (e) {
            /* storage unavailable — countdown still works for this page view */
          }
        }
        return target;
      }
      return parseInt(this.dataset.end, 10) || 0;
    }

    pad(value) {
      return String(value).padStart(2, '0');
    }

    tick() {
      const remaining = this.target - Date.now();

      if (remaining <= 0) {
        this.setValues(0, 0, 0, 0);
        if (this.interval) clearInterval(this.interval);
        this.hidden = true;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      this.setValues(days, hours, minutes, seconds);
    }

    setValues(d, h, m, s) {
      if (this.els.days) this.els.days.textContent = this.pad(d);
      if (this.els.hours) this.els.hours.textContent = this.pad(h);
      if (this.els.minutes) this.els.minutes.textContent = this.pad(m);
      if (this.els.seconds) this.els.seconds.textContent = this.pad(s);
    }
  }

  if (!customElements.get('countdown-timer-body')) {
    customElements.define('countdown-timer-body', CountdownTimerBody);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode;
      this.target = this.resolveTarget();

      this.els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    resolveTarget() {
      if (this.mode === 'evergreen') {
        const key = this.dataset.storageKey;
        const duration = parseInt(this.dataset.duration, 10) || 0;
        let stored = null;
        try {
          stored = window.localStorage.getItem(key);
        } catch (e) {
          stored = null;
        }
        let target = stored ? parseInt(stored, 10) : NaN;
        if (!target || isNaN(target) || target <= Date.now()) {
          target = Date.now() + duration;
          try {
            window.localStorage.setItem(key, String(target));
          } catch (e) {
            /* storage unavailable — countdown still works for this page view */
          }
        }
        return target;
      }
      return parseInt(this.dataset.end, 10) || 0;
    }

    pad(value) {
      return String(value).padStart(2, '0');
    }

    tick() {
      const remaining = this.target - Date.now();

      if (remaining <= 0) {
        this.setValues(0, 0, 0, 0);
        if (this.interval) clearInterval(this.interval);
        this.hidden = true;
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      this.setValues(days, hours, minutes, seconds);
    }

    setValues(d, h, m, s) {
      if (this.els.days) this.els.days.textContent = this.pad(d);
      if (this.els.hours) this.els.hours.textContent = this.pad(h);
      if (this.els.minutes) this.els.minutes.textContent = this.pad(m);
      if (this.els.seconds) this.els.seconds.textContent = this.pad(s);
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /**
   * GalleryController
   * Manages a multi-section gallery page:
   *  - Clones items from gallery-category source sections into a master grid
   *  - Handles tab filtering by category
   *  - Deduplicates items by product name when showing "All"
   */
  class GalleryController {
    constructor() {
      this.headerEl = document.querySelector('.gallery-header');
      if (!this.headerEl) return;

      this.masterGrid = document.getElementById('gallery-master-grid');
      if (!this.masterGrid) return;

      this.activeFilter = 'all';
      this.items = [];
      this.onTabClick = this.onTabClick.bind(this);

      this.bindEvents();
      this.rebuild();
    }

    destroy() {
      this.headerEl.removeEventListener('click', this.onTabClick);
    }

    /**
     * Rebuild the master grid from current section DOM and re-apply active tab.
     */
    rebuild() {
      this.masterGrid.innerHTML = '';
      this.items = [];

      var sources = document.querySelectorAll('.gallery-category-source');
      var fragment = document.createDocumentFragment();

      // Clone from sources so editor rerenders can rebuild without full page reload.
      sources.forEach(source => {
        var category = source.dataset.galleryCategory;
        var items = source.querySelectorAll('.gallery-item');

        items.forEach(item => {
          var clone = item.cloneNode(true);
          clone.dataset.galleryCategory = category;
          clone.dataset.hidden = 'false';
          clone.classList.remove('gallery-item--entering');
          fragment.appendChild(clone);
          this.items.push(clone);
        });
      });

      this.masterGrid.appendChild(fragment);

      // Show empty state if no items
      if (this.items.length === 0) {
        this.masterGrid.innerHTML = '<div class="gallery-empty"><p>No gallery items yet.</p></div>';
        return;
      }

      // Ensure active filter still exists after editor changes.
      var tabExists = this.headerEl.querySelector('[data-gallery-filter="' + this.activeFilter + '"]');
      if (!tabExists) {
        this.activeFilter = 'all';
      }

      this.applyFilter(this.activeFilter);
      this.updateActiveTab(this.activeFilter);
    }

    bindEvents() {
      this.headerEl.removeEventListener('click', this.onTabClick);
      this.headerEl.addEventListener('click', this.onTabClick);
    }

    onTabClick(e) {
      var tab = e.target.closest('[data-gallery-filter]');
      if (!tab || !this.headerEl.contains(tab)) return;

      e.preventDefault();
      var filter = tab.dataset.galleryFilter;
      if (!filter || filter === this.activeFilter) return;

      this.activeFilter = filter;
      this.applyFilter(filter);
      this.updateActiveTab(filter);
    }

    updateActiveTab(activeFilter) {
      var tabs = this.headerEl.querySelectorAll('[data-gallery-filter]');
      tabs.forEach(function(tab) {
        var isActive = tab.dataset.galleryFilter === activeFilter;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    applyFilter(filter) {
      if (filter === 'all') {
        this.showAll();
      } else {
        this.showCategory(filter);
      }
    }

    /**
     * Show all items, deduplicating by product name (case-insensitive).
     * The first occurrence of each product name is shown; duplicates are hidden.
     */
    showAll() {
      var seenKeys = {};
      var visibleCount = 0;

      this.items.forEach(function(item) {
        var rawName = (item.dataset.productName || '').trim().toLowerCase();
        var img = item.querySelector('.gallery-item__image-wrap img');
        var imgSrc = img ? (img.getAttribute('src') || '').replace(/&?width=\d+/g, '').split('?')[0] : '';
        var key = rawName + '||' + imgSrc;

        if (key !== '||' && seenKeys[key]) {
          // Duplicate (same name + same image) — hide
          item.dataset.hidden = 'true';
          item.classList.remove('gallery-item--entering');
        } else {
          if (key !== '||') seenKeys[key] = true;
          item.dataset.hidden = 'false';
          item.classList.add('gallery-item--entering');
          item.style.animationDelay = (visibleCount * 0.03) + 's';
          visibleCount++;

          var delay = 500 + visibleCount * 30;
          (function(el, d) {
            setTimeout(function() { el.classList.remove('gallery-item--entering'); }, d);
          })(item, delay);
        }
      });
    }

    /**
     * Show only items belonging to the given category.
     * No deduplication — all items in the category are shown.
     */
    showCategory(filter) {
      var visibleCount = 0;

      this.items.forEach(function(item) {
        if (item.dataset.galleryCategory === filter) {
          item.dataset.hidden = 'false';
          item.classList.add('gallery-item--entering');
          item.style.animationDelay = (visibleCount * 0.04) + 's';
          visibleCount++;

          var delay = 500 + visibleCount * 40;
          (function(el, d) {
            setTimeout(function() { el.classList.remove('gallery-item--entering'); }, d);
          })(item, delay);
        } else {
          item.dataset.hidden = 'true';
          item.classList.remove('gallery-item--entering');
        }
      });
    }
  }

  var galleryController = null;
  var refreshTimer = null;

  function initOrRefresh() {
    if (galleryController) {
      galleryController.destroy();
    }
    galleryController = new GalleryController();
  }

  function scheduleRefresh() {
    if (refreshTimer) {
      clearTimeout(refreshTimer);
    }
    refreshTimer = setTimeout(function() {
      initOrRefresh();
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrRefresh);
  } else {
    initOrRefresh();
  }

  // Theme Editor: section/block edits trigger partial rerenders.
  // Rebuild only this gallery state to avoid full-page reload.
  [
    'shopify:section:load',
    'shopify:section:unload',
    'shopify:section:reorder',
    'shopify:block:select',
    'shopify:block:deselect'
  ].forEach(function(eventName) {
    document.addEventListener(eventName, scheduleRefresh);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // When the header heart opens the Klaviyo Customer Hub drawer, mark it as a
  // favorites-only view. The class is applied for that open session only and is
  // removed when the drawer closes, so drawers opened by any other Klaviyo
  // trigger (account link, launcher, PDP favorite button) are left untouched.
  (function () {
    var FAV_CLASS = 'kl-hub-drawer--favorites-only';
    var DRAWER_SELECTOR = '.kl-hub-drawer';
    // 'idle' → nothing to do, 'armed' → heart clicked, waiting for drawer to open,
    // 'active' → favorites drawer is open.
    var state = 'idle';

    function getDrawer() {
      return document.querySelector(DRAWER_SELECTOR);
    }

    function isOpen(el) {
      if (!el || !el.isConnected) return false;
      // Visible if it participates in layout.
      return el.offsetParent !== null || el.getClientRects().length > 0;
    }

    // Enter favorites mode when the header heart is clicked. Use the capture
    // phase so we run before Klaviyo handles the #k-hub navigation.
    document.addEventListener(
      'click',
      function (event) {
        if (!event.target.closest('[data-k-hub-favorites]')) return;
        state = 'armed';
        var el = getDrawer();
        // Pre-apply if the drawer node already exists (e.g. switching from an
        // already-open drawer) to avoid a flash of the hidden sections.
        if (el) el.classList.add(FAV_CLASS);
      },
      true
    );

    // Klaviyo creates/opens the drawer asynchronously and re-renders its
    // contents, so watch the whole document and reconcile on every change.
    var observer = new MutationObserver(function () {
      var el = getDrawer();
      var open = isOpen(el);

      if (state === 'armed') {
        if (el) el.classList.add(FAV_CLASS);
        if (open) state = 'active';
      } else if (state === 'active') {
        if (!open) {
          if (el) el.classList.remove(FAV_CLASS);
          state = 'idle';
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-hidden', 'data-state'],
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-media-carousel"] && !Shopify.designMode) return;
  try {
    
class PressMediaCarousel extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    const track = this.querySelector('[data-track]');
    if (!track) return;
    this.track = track;
    this.baseItems = Array.from(track.children);
    this.build();
    this.handleResize = () => this.build();
    window.addEventListener('resize', this.handleResize);
    this.dataset.initialized = 'true';
  }

  disconnectedCallback() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  }

  build() {
    const track = this.track;
    if (!track) return;
    if (this.building) return;
    this.building = true;
    track.querySelectorAll('[data-clone="true"]').forEach((node) => node.remove());
    const items = this.baseItems;
    if (!items || items.length < 2) {
      this.classList.add('is-static');
      this.building = false;
      return;
    }
    this.classList.remove('is-static');
    const containerWidth = this.getBoundingClientRect().width;
    if (!containerWidth) {
      this.building = false;
      return;
    }
    const gapValue = getComputedStyle(track).gap || '0px';
    const gap = parseFloat(gapValue) || 0;
    const baseWidth = items.reduce((total, item) => total + item.getBoundingClientRect().width, 0) + gap * (items.length - 1);
    if (baseWidth < 1) {
      this.building = false;
      requestAnimationFrame(() => this.build());
      return;
    }
    this.style.setProperty('--pmc-translate', `${-baseWidth}px`);
    const minWidth = baseWidth + containerWidth;
    let trackWidth = track.scrollWidth;
    let loopGuard = 0;
    while (trackWidth < minWidth && loopGuard < 10) {
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.dataset.clone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      trackWidth = track.scrollWidth;
      loopGuard += 1;
    }
    this.building = false;
  }
}

if (!customElements.get('press-media-carousel')) {
  customElements.define('press-media-carousel', PressMediaCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-scroll-showcase]');

    sections.forEach(function (section) {
      var panel = section.querySelector('[data-showcase-panel]');
      var items = section.querySelectorAll('[data-showcase-item]');
      var media = section.querySelectorAll('[data-media-index]');
      if (!panel || !items.length || !media.length) return;

      var count = items.length;
      var current = -1;
      var ticking = false;

      function setActive(index) {
        if (index === current) return;
        current = index;
        items.forEach(function (item, i) {
          item.classList.toggle('is-active', i === index);
        });
        media.forEach(function (m, i) {
          m.classList.toggle('is-active', i === index);
        });
      }

      function update() {
        ticking = false;
        var rect = panel.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        if (viewportHeight <= 0) return;

        // Position of the panel's vertical center within the viewport (0 = top, 1 = bottom)
        var center = rect.top + rect.height / 2;
        var ratio = center / viewportHeight;

        // Zones step down from the top boundary in equal slices:
        // ratio >= 0.8 -> 1st, 0.6~0.8 -> 2nd, 0.4~0.6 -> 3rd, < 0.4 -> 4th
        var TOP_BOUNDARY = 0.8;
        var ZONE_SIZE = 0.2;

        var index;
        if (ratio >= TOP_BOUNDARY) {
          index = 0;
        } else {
          index = Math.floor((TOP_BOUNDARY - ratio) / ZONE_SIZE) + 1;
        }

        if (index > count - 1) index = count - 1;
        if (index < 0) index = 0;
        setActive(index);
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
